// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-inline: 14px;
  background: #FFFFFF;
}
.header .type-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.5px solid rgba(38, 38, 38, 0.5019607843);
  padding-bottom: 10px;
}
.header .type-block {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}
.header .type-block .button-type {
  min-width: 88px;
  min-height: 30px;
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000000;
  background: transparent;
  border-radius: 26px;
  text-transform: uppercase;
  font-family: AppFontMedium, sans-serif;
  background: #ebdfda;
}
.header .type-block .button-type.selected {
  background: var(--ion-color-primary);
  color: #FFFFFF;
}
.header .title {
  width: 100%;
  font-size: 14px;
  line-height: 12px;
  letter-spacing: 8%;
  text-align: center;
  font-weight: 700;
  color: #000000;
}

.menu-block {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.delivery-btn {
  width: 40px;
  height: 40px;
  background: #B0A572;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.delivery-btn.burger {
  background: transparent;
  border: 1px solid #B0A572;
}
.delivery-btn ion-icon {
  width: 24px;
  height: 24px;
}

.back {
  width: 25px;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/header/header.component.scss"],"names":[],"mappings":"AAEA;EACC,WAAA;EACA,YAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EAEA,mBAAA;AAHD;AAOC;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yDAAA;EACA,oBAAA;AALF;AASC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAPF;AASE;EACC,eAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACC,uBAAA;EACA,mBAAA;EACD,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sCAAA;EACA,mBAAA;AAPH;AAQG;EACC,oCAAA;EACA,cAAA;AANJ;AAWC;EACC,WAAA;EAEA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EAKA,cAAA;AAdF;;AAiBA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAdD;;AAgBA;EACC,WAAA;EACG,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAbJ;AAcC;EACC,uBAAA;EACA,yBAAA;AAZF;AAcC;EACC,WAAA;EACA,YAAA;AAZF;;AAeA;EACC,WAAA;EACA,YAAA;AAZD","sourcesContent":["@import '../../../theme/mixins';\n\n.header {\n\twidth: 100%;\n\theight: 80px;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding-inline: 14px;\n\n\tbackground: #FFFFFF;\n\t// border-bottom: 1px solid #E5E5E5;\n\n\n\t.type-row {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tborder-bottom: 0.5px solid #26262680;\n\t\tpadding-bottom: 10px;\n\t\t// margin-bottom: 18px;\n\t}\n\n\t.type-block {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tgap: 5px;\n\n\t\t.button-type {\n\t\t\tmin-width: 88px;\n\t\t\tmin-height: 30px;\n\t\t\tfont-size: 10px;\n\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\tcolor: #000000;\n\t\t\tbackground: transparent;\n\t\t\tborder-radius: 26px;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-family: AppFontMedium, sans-serif;\n\t\t\tbackground: #ebdfda;\n\t\t\t&.selected {\n\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\tcolor: #FFFFFF;\n\t\t\t}\n\t\t}\n\t}\n\n\t.title {\n\t\twidth: 100%;\n\n\t\tfont-size: 14px;\n\t\tline-height: 12px;\n\t\tletter-spacing: 8%;\n\t\ttext-align: center;\n\t\tfont-weight: 700;\n\t\t// text-transform: uppercase;\n\n\t\t// padding-bottom: 10px;\n\t\t// border-bottom: 1px solid #B5B5B5;\n\t\tcolor: #000000;\n\t}\n}\n.menu-block {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 10px;\n}\n.delivery-btn {\n\twidth: 40px;\n    height: 40px;\n    background: #B0A572;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\t&.burger {\n\t\tbackground: transparent;\n\t\tborder: 1px solid #B0A572;\n\t}\n\tion-icon {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t}\n}\n.back {\n\twidth: 25px;\n\theight: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
